.aha-comment-reply {
  display: flex;
  gap: var(--spacer-3);
  width: 100%;
}

.aha-comment-reply__body {
  width: 100%;
}
